'use client'
import { useQuery } from '@tanstack/react-query'
import * as React from 'react'
import { useUserStore } from '~/app/_store/user-store'
import { getFlags } from './action'
import type { Flags } from './definitions'

const Context = React.createContext<Partial<Flags>>({})

export const FlagsProvider = ({ children }: { children?: React.ReactNode }) => {
  const optimisticUser = useUserStore((s) => s.optimisticUser)

  const { data } = useQuery<Partial<Flags>>(
    ['flags', optimisticUser?.id, optimisticUser?.email],
    async () => {
      const flags = await getFlags()

      // if (
      //   [
      //     '@scale.com',
      //     '@scale.ai',
      //     '@shape.us',
      //     '@basehub.com',
      //     '@basement.studio',
      //     '@vercel.com',
      //     'julianbenegas99@gmail.com',
      //   ].some((domain) => optimisticUser?.email?.endsWith(domain))
      // ) {
      //   flags.branching = true
      // }

      // set it free (not sure how to control this at the flag level)
      flags.branching = true

      return flags
    },
    {
      enabled: !!optimisticUser,
      initialData: {
        branching: true,
      },
    }
  )

  return <Context.Provider value={data}>{children}</Context.Provider>
}

export const useFlags = () => {
  const ctx = React.useContext(Context)
  if (!ctx) {
    throw new Error('useFlags must be used within a FlagsProvider')
  }
  return ctx
}
